module.exports = function HelpCenter(ProxyService, $http) {
    const ZENDESK_BASE_URL = window.config.ZENDESK_BASE_URL;
    const HELP_CENTER_SEARCH_V2 = window.config.HELP_CENTER_SEARCH_V2;
    const HELP_CENTER_CATEGORIES = window.config.HELP_CENTER_CATEGORIES;
    const HELP_CENTER_CATEGORY_SECTIONS = window.config.HELP_CENTER_CATEGORY_SECTIONS;
    const HELP_CENTER_SECTION_ARTICLES = window.config.HELP_CENTER_SECTION_ARTICLES;

    // Initialize properties
    this.proxyService = ProxyService;
    this.$http = $http;
    this.zendeskSearchURL = `${ZENDESK_BASE_URL}${HELP_CENTER_SEARCH_V2}`;
    this.zendeskCategoriesURL = `${ZENDESK_BASE_URL}${HELP_CENTER_CATEGORIES}`;
    this.zendeskSectionsURL = `${ZENDESK_BASE_URL}${HELP_CENTER_CATEGORY_SECTIONS}`;
    this.zendeskArticlesURL = `${ZENDESK_BASE_URL}${HELP_CENTER_SECTION_ARTICLES}`;

    // Function to search help center articles
    this.getHelpCenterSearch = function (query) {
        console.log("Search Query:", query);
        console.log("Search URL:", this.zendeskSearchURL);

        // Perform the HTTP GET request and return the result
        return this.$http.get(this.zendeskSearchURL + query)
            .then((response) => {
                return response.data; // Return the response data
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                return Promise.reject(error); // Propagate the error
            });
    };

    this.getCategories = function () {
        console.log("#### URL:", this.zendeskCategoriesURL);

        return this.$http.get(this.zendeskCategoriesURL)
            .then((response) => {
                return response.data.categories;
            })
            .catch((error) => {
                console.error("Error fetching categories:", error);
                return Promise.reject(error);
            });
    };

    this.getSectionsByCategoryId = function (categoryId) {
        const url = this.zendeskSectionsURL.replace('{categoryId}', categoryId);
        return this.$http.get(url)
            .then((response) => {
                return response.data.sections;
            })
            .catch((error) => {
                console.error("Error fetching sections:", error);
                return Promise.reject(error);
            });
    };

    this.getArticlesBySectionId = function (sectionId) {
        const url = this.zendeskArticlesURL.replace('{sectionId}', sectionId);
        return this.$http.get(url)
            .then((response) => {
                return response.data.articles;
            })
            .catch((error) => {
                console.error("Error fetching articles:", error);
                return Promise.reject(error);
            });
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/help-center-service.js
 **/